<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="canEdit"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <action-toolbar-search name="brakesSearch" [(ngModel)]="grid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid id="mainGrid" #mainGrid appAutoSize (initialized)="grid.initialize(mainGrid)" (destroy)="grid.destroy()" [itemsSource]="grid.view">
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="'*'" [dataMap]="equipmentDataMap">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'equipment', equipment: cell.item.equipment }">{{
                        parent.equipmentDisplay(cell.item.equipment)
                    }}</a>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 1 Pads'" [binding]="'axle1Pads'" [width]="'*'">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    @if (cell.item.axle1Pads) {
                        <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'item', item: cell.item.axle1Pads }">{{ cell.item.axle1Pads }}</a>
                    }
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 1 Drum/Rotor'" [binding]="'axle1DrumRotor'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 2 Pads'" [binding]="'axle2Pads'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 2 Drum/Rotor'" [binding]="'axle2DrumRotor'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 3 Pads'" [binding]="'axle3Pads'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 3 Drum/Rotor'" [binding]="'axle3DrumRotor'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 4 Pads'" [binding]="'axle4Pads'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Axle 4 Drum/Rotor'" [binding]="'axle4DrumRotor'" [width]="'*'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
